import { FunctionComponent } from 'react'

type CloseProps = {
  fillColor?: string
}

const Close: FunctionComponent<CloseProps & any> = ({ fillColor = 'white', ...otherProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...otherProps}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.70711 1.29289C2.31658 0.902369 1.68342 0.902369 1.29289 1.29289C0.902369 1.68342 0.902369 2.31658 1.29289 2.70711L6.52438 7.93859L1.29289 13.1701C0.902369 13.5606 0.902369 14.1938 1.29289 14.5843C1.68342 14.9748 2.31658 14.9748 2.70711 14.5843L7.93859 9.3528L13.2907 14.7049C13.6812 15.0954 14.3143 15.0954 14.7049 14.7049C15.0954 14.3143 15.0954 13.6812 14.7049 13.2907L9.3528 7.93859L14.5843 2.70711C14.9748 2.31658 14.9748 1.68342 14.5843 1.29289C14.1938 0.902369 13.5606 0.902369 13.1701 1.29289L7.93859 6.52438L2.70711 1.29289Z'
        fill={fillColor}
      />
    </svg>
  )
}

export default Close
